<!--
 * @Author: your name
 * @Date: 2022-06-09 11
-->
<!-- 维修视频 -->
<template>
	<div class="originality-story">
			<p>正在建设中，敬请期待......</p> 
	</div>
</template>
<script>
export default {
	data() {
		return {

		}
	},
};
</script>
<style lang="scss">
@import "./originality-story.scss";
</style>



// WEBPACK FOOTER //
// src/views/brand-story/originality-story/originality-story.vue